import TOKEN from '../TOKEN';

const createMention =
  ({ source, users }) =>
  ({ 0: text, 1: pre, index }) => {
    // NOTE: We need to pick the longest match (not the first match).
    // This is because the first match could be a substring of the longest match.
    // Example: `@Al Smith` is a substring of `@Al Smith, Sr.`
    const user = users
      .filter(({ name }) => source.startsWith(name, index + text.length))
      .reduce((prev, next) => (prev?.name?.length > next.name.length ? prev : next), undefined);
    return !user
      ? undefined
      : {
          type: TOKEN.MENTION,
          text: `@${user.name}`,
          index: index + pre.length,
          user,
        };
  };

createMention.regex = /(^|\W)@/g;

export default createMention;
